import { definePanel } from '@/app/definePanel';
import { OrganizationIcon } from '@/components/occurra/icons/OrganizationIcon';
import { PanelMode, PanelTheme } from '@/types/panels';

export default definePanel({
    id: 'organization_settings',
    title: 'Organization settings',
    description: 'Locations, archive encryption and the settings of the agents.',
    icon: OrganizationIcon,
    // A 240px rail beside a section pane, as in camera settings.
    width: { min: 480, default: 800, max: 800, fill: false },
    modes: [PanelMode.Settings],
    themes: PanelTheme.Any,
    // Right after Servers in the rail.
    order: 3.45,
    // The panel draws the header of each pane itself.
    isHeaderless: true,
    urlSyncedProps: [],
});
